import type { RefObject } from 'react';
import { fadeFromTo, fadeTo } from 'util/animation/fade/fade';
import type { CtaRefType } from '../../../util/cta/cta.data';
import { hideRectangle, revealRectangle } from '../../../util/animation/reveal/reveal';

interface ImageModalRefs {
  closeButtonRef: RefObject<CtaRefType | null>;
  elementRef: RefObject<HTMLElement | null>;
  backgroundRef: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { closeButtonRef, elementRef, backgroundRef }: ImageModalRefs,
): void {
  timeline.add(fadeFromTo(elementRef.current as HTMLElement, { duration: 0.01, autoAlpha: true }));

  timeline.add(fadeFromTo(backgroundRef.current as HTMLElement), 0);
  timeline.add(
    revealRectangle(elementRef.current as HTMLElement, {
      from: 'center',
    }),
    0.1,
  );

  timeline.add(fadeFromTo(closeButtonRef.current as HTMLElement));
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, closeButtonRef, backgroundRef }: ImageModalRefs,
): void {
  timeline.add(fadeTo(backgroundRef.current as HTMLElement), 0);
  timeline.add(fadeTo(closeButtonRef.current as HTMLElement), 0);

  timeline.add(
    hideRectangle(elementRef.current as HTMLElement, {
      to: 'center',
    }),
    0,
  );
  timeline.add(fadeTo(elementRef.current as HTMLElement, { duration: 0.01 }));
}
